module.exports = __webpack_public_path__ + "static/media/feature-slideg3.81b2ce4c.jpg";